<template>
	<div>
		<div class="pb-2" v-if="salesProduct.length == 0">
			<not-found></not-found>
		</div>
		<div class="pr-2 mt-n2" v-else>
			<apexchart type="bar" height="310" :options="chartOptions" :series="salesProduct"></apexchart>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState } from 'vuex'
import apexchart from 'vue-apexcharts'

export default {
	components: {
		apexchart,
	},
	data() {
		return {
			series: [{
				name: 'KMU',
				data: [44, 55, 57, 56, 61, 58, 63, 60, 66, 20, 50, 58]
			}, {
				name: 'KPM',
				data: [76, 85, 101, 98, 87, 105, 91, 114, 94, 83, 76, 25]
			}],
			chartOptions: {
				chart: {
					type: 'bar',
					toolbar: {
						show: false,
					}
				},
				colors: ['#512DA8', '#B388FF', '#42A5F5', '#1565C0'],
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: '55%',
						endingShape: 'rounded',
						dataLabels: {
							position: 'top',
						},
					},
				},
				legend: {
					horizontalAlign: 'left',
				},
				dataLabels: {
					enabled: true,
					formatter: (val) => {
						if (val)
							return this.$options.filters.toNumber(val)
						else
							return ''
					},
					distributed: true,
					offsetY: -20,
					style: {
						colors: ["#304758"]
					},
				},
				stroke: {
					show: true,
					width: 2,
					colors: ['transparent']
				},
				xaxis: {
					categories: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Oct', 'Nov', 'Des'],
				},
				yaxis: {
				},
				fill: {
					opacity: 1,
				},
				tooltip: {
					y: {
						formatter: function (val) {
							return val + " terjual"
						}
					}
				}
			},
		}
	},
	computed: {
		...mapState('dashboard', ['listSalesProduct']),

		salesProduct() {
			let data = Object.keys(this.listSalesProduct).map((val) => this.listSalesProduct[val])
			data.forEach(function(val) {
				val.name = val.product_code
				val.data = val.quantity
				delete val.product_code
				delete val.quantity
			})
			return data
		}
	},
	methods: {
		...mapActions('dashboard', ['getSalesProduct']),
	},
	created() {
		this.getSalesProduct()
	}
}
</script>